import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("TitleBar"), _c("div", {
    staticClass: "text-con"
  }, [_c("h4", [_vm._v(_vm._s(_vm.$t("ChooseYourInterest")))]), _c("span", [_vm._v("Recommend more exciting content for you.")])]), _vm.isShow ? _c("div", {
    staticClass: "select-con"
  }, _vm._l(_vm.arr, function (itm, index) {
    return _c("div", {
      key: itm.id,
      class: ["item", {
        selected: itm.selected
      }],
      on: {
        click: function click($event) {
          return _vm.toSelect(itm);
        }
      }
    }, [itm.selected ? _c("img", {
      staticClass: "img",
      attrs: {
        src: require("../../assets/images/ic_common_caed_selected.png"),
        alt: ""
      }
    }) : _c("img", {
      staticClass: "img",
      attrs: {
        src: require("../../assets/images/ic_common_caed_add.png"),
        alt: ""
      }
    }), _c("div", {
      staticClass: "icon-con"
    }, [index % 3 == 0 && !itm.selected ? _c("img", {
      staticClass: "icon",
      attrs: {
        src: require("../../assets/images/ic_choose_hot_normal.png"),
        alt: ""
      }
    }) : _vm._e(), index % 3 == 0 && itm.selected ? _c("img", {
      staticClass: "icon",
      attrs: {
        src: require("../../assets/images/ic_choose_hot_disabled.png"),
        alt: ""
      }
    }) : _vm._e(), index % 3 == 1 && !itm.selected ? _c("img", {
      staticClass: "icon",
      attrs: {
        src: require("../../assets/images/ic_choose_clue_normal.png"),
        alt: ""
      }
    }) : _vm._e(), index % 3 == 1 && itm.selected ? _c("img", {
      staticClass: "icon",
      attrs: {
        src: require("../../assets/images/ic_choose_clue_disabled.png"),
        alt: ""
      }
    }) : _vm._e(), index % 3 == 2 && !itm.selected ? _c("img", {
      staticClass: "icon",
      attrs: {
        src: require("../../assets/images/ic_choose_activity_normal.png"),
        alt: ""
      }
    }) : _vm._e(), index % 3 == 2 && itm.selected ? _c("img", {
      staticClass: "icon",
      attrs: {
        src: require("../../assets/images/ic_choose_activity_disabled.png"),
        alt: ""
      }
    }) : _vm._e(), _c("span", [_vm._v(_vm._s(itm.description))])])]);
  }), 0) : _vm._e(), _c("div", {
    staticClass: "btn",
    on: {
      click: _vm.toSave
    }
  }, [_vm._v(_vm._s(_vm.$t("Save")))])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };